// removed by extract-text-webpack-plugin
module.exports = {"root":"AuthorSubscribe__root--25ZbV","featured":"AuthorSubscribe__featured--TsglR","caret":"AuthorSubscribe__caret--30Ydq","close":"AuthorSubscribe__close--20v97 AuthorSubscribe__caret--30Ydq","left":"AuthorSubscribe__left--3lsTl AuthorSubscribe__caret--30Ydq","right":"AuthorSubscribe__right--a14uh AuthorSubscribe__caret--30Ydq","subscribe":"AuthorSubscribe__subscribe--1KNnL","bounce":"AuthorSubscribe__bounce--3x19J"};


//////////////////
// WEBPACK FOOTER
// ./src/author/components/AuthorSubscribe/AuthorSubscribe.css
// module id = ./src/author/components/AuthorSubscribe/AuthorSubscribe.css
// module chunks = 1